import { FC } from 'react';
import { formatCurrency } from '../../utils/format/formatCurrency';
import { Flex } from '../layout/Flex';
import { NumberTypography } from './styles';
import { PriceProps } from './types';

export const Price: FC<PriceProps> = ({
    priceInfo,
    oldPriceInfo,
    isMultipleProducts,
    ...other
}) => {
    if (!priceInfo || priceInfo.integerPart === undefined || priceInfo.integerPart === null) {
        return null;
    }

    return (
        <Flex direction="row" alignItems="baseline">
            <NumberTypography
                variant={isMultipleProducts ? 'body2' : 'body'}
                weight="bold"
                lines={1}
                color="var(--control-primary-background)"
                {...other}
            >
                {priceInfo.formatted
                    ? priceInfo.formatted
                    : formatCurrency(priceInfo.integerPart, priceInfo.fractionalPart)}
            </NumberTypography>
            {oldPriceInfo?.integerPart ? (
                <NumberTypography
                    variant="body2"
                    color="var(--control-disabled-color)"
                    textTransform="none"
                    textDecoration="line-through"
                    lines={1}
                    ml={1}
                >
                    {formatCurrency(oldPriceInfo.integerPart, oldPriceInfo.fractionalPart)}
                </NumberTypography>
            ) : null}
        </Flex>
    );
};
